(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-heading"]) return;
  try {
    
  function setupCollectionDescriptionToggles(root) {
    var scope = root || document;
    var descriptions = scope.querySelectorAll('[data-codex-collection-description]');

    descriptions.forEach(function (description) {
      var toggle = description.nextElementSibling;

      if (!toggle || !toggle.matches('[data-codex-collection-toggle]')) return;

      var isOverflowing = description.scrollHeight > description.clientHeight + 4;
      toggle.hidden = !isOverflowing;
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-codex-collection-toggle]');

    if (!toggle) return;

    var description = toggle.previousElementSibling;

    if (!description || !description.matches('[data-codex-collection-description]')) return;

    var isExpanded = description.classList.toggle('is-expanded');
    description.classList.toggle('is-collapsed', !isExpanded);
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.textContent = isExpanded ? toggle.dataset.showLess : toggle.dataset.readMore;
  });

  document.addEventListener('DOMContentLoaded', function () {
    setupCollectionDescriptionToggles(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setupCollectionDescriptionToggles(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
